export class EntityModel {
    constructor(data = {}) {
        this.id = data.id ?? null;
        this.createdAt = data.createdAt ?? null;
        this.updatedAt = data.updatedAt ?? null;
        this.naicId = data.naicId ?? null;
        this.pbmId = data.pbmId ?? null;
        this.name = data.name ?? null;
        this.type = data.type ?? null;
        this.status = data.status ?? null;
    }
}
